import OrderInfo from './order-info/index.vue';
import UserInfo from './user-info/index.vue';
import ReceivePayment from './receive-payment/index.vue';
import AuditForm from './audit-form/index.vue';
import AssignedUser from './assigned-user/index.vue';
import Service from '../orders.service.js';
import SubsidyAuditForm from './subsidy-audit-form/index.vue';
import ImageViewer from '@/components/image-viewer/index.vue';
import YanShou from '../trusteeship/detail/yanshou/index.vue';
export default {
  components: {
    OrderInfo,
    UserInfo,
    ReceivePayment,
    AuditForm,
    ImageViewer,
    AssignedUser,
    SubsidyAuditForm,
    YanShou
  },
  data: () => {
    return {
      type: '',
      isCheck: false,
      info: {},
      trackingList: [],
      showDialog: false
    };
  },
  computed: {
    isTrust() {
      if (!this.info.category) return false;
      return this.info.category.indexOf('001') === 0;
    },

    isShowReceivePayment() {
      const status = this.info.status;
      if (this.info.payDate) {
        return true;
      }
      if (status === '030' && this.isCheck) {
        return true;
      }
      return false;
    },
    desc() {
      var str = ['非常差', '差', '一般', '好', '非常好'];
      if (!this.info.score) return '';
      return str[this.info.score-1];
    }
  },

  created() {
    this.type = this.$route.query && this.$route.query.type;
    this.isCheck = this.$route.query && this.$route.query.check === 'true';
    this.getOrderDetail();
    // this.getTrackingList();
  },

  methods: {
    getOrderDetail() {
      Service.getOrderDetail(this.$route.query.id).then(res => {
        this.info = res;
        // this.setBreadCrumbList();
      });
    },

    setBreadCrumbList() {
      let path = '/app/service-order/list/' + this.info.category.substring(0, 3);
      const listBreadCrumb = [
        { path: path, title: '服务管理列表'},
        { path: '/app/service-order/detail', title: '服务详情'}
      ];
      this.$store.commit('UPDATE_BREAD_CRUMB_LIST', listBreadCrumb);
    },

    getTrackingList() {
      Service.getTrackingList(this.$route.query.id).then(res => {
        this.trackingList = res;
      });
    },

    back() {
      this.$router.back();
    }
  }
};
